module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"submitButton":"Ok, entendi"},"en-US":{"submitButton":"Ok"}}')
  delete Component.options._Ctor
}
